module.exports = __webpack_public_path__ + "img/successs.85a08b3f.svg";